import { MarketingPage } from './pages';

export const marketingRoutes = [
  {
    path: 'marketing',
    component: MarketingPage,
    requiredPermission: 'marketing.view',
  },
];
